import { createContext as x, useContext as P, useMemo as w, useReducer as ae, useRef as j, useEffect as ie, useCallback as C, useState as ue } from "react";
import { jsx as v, jsxs as le } from "react/jsx-runtime";
import { QueryClient as de, QueryClientProvider as he, useQueryClient as $, useQuery as fe, useInfiniteQuery as pe } from "@tanstack/react-query";
import { useRequester as ge } from "@made-people/react-use-requester";
import { useInjectStructuredDataProducts as Se } from "@made-people/grease-structured-data";
const b = x(
  void 0
), H = x(void 0);
function ye() {
  const e = P(H);
  if (e === void 0)
    throw new Error(
      "useFacetSorting must be used within a SearchResultProvider"
    );
  return e;
}
const N = x([]), me = () => {
  const e = P(N);
  if (e === void 0)
    throw new Error("useExcludedFacets must be used within a SearchProvider");
  return e;
}, we = new de({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1e3,
      // 5 minutes
      gcTime: 30 * 60 * 1e3,
      // 30 minutes
      retry: 2,
      retryDelay: (e) => Math.min(1e3 * 2 ** e, 3e4)
    },
    mutations: {
      retry: 1
    }
  }
}), G = ({
  children: e,
  queryClient: t = we
}) => /* @__PURE__ */ v(he, { client: t, children: e });
G.displayName = "SearchResultReactQueryProvider";
const W = x(
  null
), ve = () => P(W), Pe = (e) => {
  var n, a;
  const t = {
    globalSearchSettings: e.globalSearchSettings,
    searchData: e.searchData,
    structuredDataMapper: e.structuredDataMapper
  }, r = {
    facets: ((n = e.facetSorting) == null ? void 0 : n.facets) ?? "auto",
    values: ((a = e.facetSorting) == null ? void 0 : a.values) ?? "auto"
  }, s = e.excludedFacets ?? [];
  return /* @__PURE__ */ v(b.Provider, { value: t, children: /* @__PURE__ */ v(N.Provider, { value: s, children: /* @__PURE__ */ v(W.Provider, { value: e.facetGrouping ?? null, children: /* @__PURE__ */ v(H.Provider, { value: r, children: /* @__PURE__ */ v(G, { children: e.children }) }) }) }) });
};
Pe.displayName = "SearchProvider";
const Ne = {
  search: "search"
}, B = x(void 0), Ge = (e) => {
  const t = {
    autoCompleteClient: e.autoCompleteClient
  };
  return /* @__PURE__ */ v(B.Provider, { value: t, children: e.children });
}, xe = () => {
  const e = P(B);
  if (!e)
    throw new Error(
      "useAutoCompleteClient must be used within a AutoCompleteProvider"
    );
  return e.autoCompleteClient;
}, We = () => {
  const e = xe();
  return ge(async (r) => {
    try {
      return await e.search(r);
    } catch (s) {
      throw s;
    }
  });
};
function Re(e, t) {
  switch (t.type) {
    case "SET_RESULT":
      return {
        ...e,
        result: t.payload
      };
    case "LOAD_PAGE":
      return e.result ? {
        ...e,
        result: {
          ...e.result,
          items: [...e.result.items, ...t.payload.items],
          meta: {
            ...e.result.meta,
            currentPage: t.payload.page
          }
        }
      } : e;
    default:
      return e;
  }
}
const Z = x(void 0), z = x(void 0);
function F() {
  const e = P(Z);
  if (e === void 0)
    throw new Error(
      "useSearchResultState must be used within a SearchResultProvider"
    );
  return e;
}
function Ce() {
  var t;
  return (t = F().result) == null ? void 0 : t.items;
}
const J = () => {
  const e = P(b);
  if (!e)
    throw new Error(
      "useStructuredDataProductsMapper must be used within a SearchProvider"
    );
  return e.structuredDataMapper;
}, be = (e) => {
  const t = Ce(), r = J(), s = w(() => {
    if (!r)
      return;
    const n = [];
    return t == null || t.forEach((a) => {
      a.type === "product" && n.push(r(a.product));
    }), n;
  }, [t]);
  return Se(s), null;
}, X = x(void 0), Y = (e) => {
  const [t, r] = ae(Re, {
    result: e.result
  }), s = j(!0), n = J();
  return ie(() => {
    s.current ? s.current = !1 : r({ type: "SET_RESULT", payload: e.result });
  }, [e.result]), /* @__PURE__ */ v(Z.Provider, { value: t, children: /* @__PURE__ */ le(z.Provider, { value: r, children: [
    n && /* @__PURE__ */ v(be, {}),
    e.children
  ] }) });
};
Y.displayName = "SearchResultProvider";
const Fe = (e, t, r) => {
  const s = t && Object.keys(t).length > 0, n = r && r.length > 0;
  return s && n ? ["search", e, "facets", t, "sort", r] : s ? ["search", e, "facets", t] : n ? ["search", e, "sort", r] : ["search", e];
}, E = (e, t, r) => Fe(
  e,
  Object.keys(t).length > 0 ? t : void 0,
  r.length > 0 ? r : void 0
), Q = (e, t) => {
  const r = e.values.map((n) => n.id === t ? {
    ...n,
    selected: !n.selected
  } : n), s = r.filter((n) => n.selected).length;
  return {
    ...e,
    values: r,
    selectedCount: s
  };
}, q = (e, t) => e.map((r) => {
  if (r.id === t) {
    const s = !r.selected;
    if (r.children && r.children.length > 0) {
      const n = (a) => a.map((o) => ({
        ...o,
        selected: s,
        children: o.children ? n(o.children) : o.children
      }));
      return {
        ...r,
        selected: s,
        children: n(r.children)
      };
    } else
      return {
        ...r,
        selected: s
      };
  }
  return r.children ? {
    ...r,
    children: q(r.children, t)
  } : r;
}), ee = (e) => e.map((t) => {
  if (t.children && t.children.length > 0) {
    const r = ee(t.children), s = r.every(
      (n) => n.selected
    );
    return {
      ...t,
      selected: s,
      children: r
    };
  }
  return t;
}), k = (e, t) => {
  const r = q(e.values, t), s = ee(r), n = (o) => o.reduce((u, c) => {
    let d = c.selected ? 1 : 0;
    return c.children && (d += n(c.children)), u + d;
  }, 0), a = n(s);
  return {
    ...e,
    values: s,
    selectedCount: a
  };
}, I = (e) => {
  const t = [];
  for (const r of e)
    r.selected && t.push(r), r.children && t.push(
      ...I(r.children)
    );
  return t;
}, Ee = (e) => {
  const t = [], r = (s) => {
    for (const n of s) {
      if (n.selected) {
        t.push(n);
        continue;
      }
      n.children && n.children.length > 0 && r(n.children);
    }
  };
  return r(e), t;
}, Qe = async (e, t, r, s) => {
  let n = e;
  for (const [a, o] of Object.entries(t)) {
    const u = n.facets.find((d) => d.id === a);
    if (!u)
      continue;
    let c = [...n.facets];
    for (const d of o)
      u.type === "checkbox" ? c = c.map((l) => l.id === a && l.type === "checkbox" ? Q(l, d) : l) : u.type === "checkbox-hierarchical" && (c = c.map((l) => l.id === a && l.type === "checkbox-hierarchical" ? k(l, d) : l));
    n = await s.setFacets(c, n);
  }
  if (r.length > 0) {
    const a = n.sort.map((o) => ({
      ...o,
      selected: r.includes(o.id)
    }));
    n = await s.setSortOrder(
      a,
      n
    );
  }
  return n;
}, D = (e) => {
  if (!e)
    return { facets: {}, sort: [] };
  const t = e.facets.reduce(
    (s, n) => {
      const a = T(n);
      return a.length > 0 && (s[n.id] = a), s;
    },
    {}
  ), r = te(e.sort || []);
  return { facets: t, sort: r };
}, te = (e) => e.filter((t) => t.selected).map((t) => t.id).sort(), L = (e) => {
  const t = [];
  return Object.keys(e.facets).length > 0 && t.push("facets", e.facets), e.sort.length > 0 && t.push("sort", e.sort), t;
}, T = (e) => {
  var r, s;
  let t = [];
  return e.type === "checkbox-hierarchical" ? t = re(
    e.values
  ) : e.type === "group" ? t = e.children.flatMap(
    (n) => T(n)
  ) : t = ((s = (r = e.values) == null ? void 0 : r.filter((n) => n.selected)) == null ? void 0 : s.map((n) => n.id)) || [], t.sort();
}, re = (e) => {
  const t = [];
  for (const r of e)
    r.selected && t.push(r.id), r.children && t.push(...re(r.children));
  return t;
}, ke = (e) => {
  const t = {};
  return e.forEach((r, s) => {
    if (s.startsWith("facet_")) {
      const n = s.replace("facet_", "");
      t[n] = r.split(",");
    }
  }), t;
}, Ie = (e) => {
  const t = e.get("sort");
  return t ? t.split(",") : [];
}, M = (e, t, r, s) => {
  const n = new URLSearchParams(r);
  for (const [o] of r.entries())
    o.startsWith("facet_") && n.delete(o);
  n.delete("sort"), e.forEach((o) => {
    let u = [];
    o.type === "checkbox" ? u = o.values.filter((c) => c.selected).map((c) => c.id) : o.type === "checkbox-hierarchical" ? u = I(o.values).map((d) => d.id) : o.type === "group" && o.children.forEach((c) => {
      let d = [];
      c.type === "checkbox" ? d = c.values.filter((l) => l.selected).map((l) => l.id) : c.type === "checkbox-hierarchical" && (d = I(c.values).map((i) => i.id)), d.length > 0 && n.set(
        `facet_${c.id}`,
        d.join(",")
      );
    }), o.type !== "group" && u.length > 0 && n.set(`facet_${o.id}`, u.join(","));
  });
  const a = t.filter((o) => o.selected).map((o) => o.id);
  a.length > 0 && n.set("sort", a.join(",")), window.history.replaceState(
    null,
    "",
    `${s}?${n.toString()}`
  );
}, Be = (e, t) => {
  const r = new URLSearchParams(e);
  for (const [s] of e.entries())
    s.startsWith("facet_") && r.delete(s);
  r.delete("sort"), window.history.replaceState(
    null,
    "",
    `${t}?${r.toString()}`
  );
}, De = (e, t, r, s, n) => async (a, o) => {
  var c, d;
  const u = ((c = e.data) == null ? void 0 : c.pages.length) || 0;
  if (a === u + 1) {
    const l = await e.fetchNextPage(), i = (d = l.data) == null ? void 0 : d.pages[l.data.pages.length - 1], g = n();
    if (l.data && g) {
      const h = l.data.pages.flatMap(
        (S) => Array.isArray(S) ? S : S && typeof S == "object" && "items" in S ? S.items : []
      ), y = {
        ...g,
        items: h,
        meta: {
          ...g.meta,
          currentPage: l.data.pages.length
        }
      };
      r.setQueryData(s, y);
    }
    return i && typeof i == "object" && "items" in i ? i.items : [];
  }
  return await t.loadPage(a, o);
}, Le = (e, t, r, s, n, a, o, u) => ({
  ...e,
  // Apply facet filters while maintaining cache and URL state
  setFacets: async (c, d) => {
    const l = await e.setFacets(
      c,
      d
    ), i = (s == null ? void 0 : s.sort) || [], { urlFacetsData: g, urlSortData: h } = u(
      c,
      i
    ), y = E(
      r,
      g,
      h
    );
    return t.setQueryData(y, l), o(l), M(
      c,
      i,
      n,
      a
    ), l;
  },
  // Apply sort order changes while maintaining cache and URL state
  setSortOrder: async (c, d) => {
    const l = await e.setSortOrder(
      c,
      d
    ), i = (s == null ? void 0 : s.facets) || [], { urlFacetsData: g, urlSortData: h } = u(
      i,
      c
    ), y = E(
      r,
      g,
      h
    );
    return t.setQueryData(y, l), o(l), M(
      i,
      c,
      n,
      a
    ), l;
  },
  reset: async () => {
    const c = E(r, {}, []), d = t.getQueryData(c);
    if (d) {
      await t.cancelQueries({
        queryKey: ["search", r, "infinite"],
        exact: !1
      }), t.removeQueries({
        queryKey: ["search", r, "infinite"],
        exact: !1
      });
      const h = new URLSearchParams(n);
      for (const [f] of n.entries())
        f.startsWith("facet_") && h.delete(f);
      h.delete("sort");
      const y = h.toString(), S = y ? `${a}?${y}` : a;
      return window.history.replaceState(null, "", S), await t.invalidateQueries({
        queryKey: ["search", r],
        exact: !1
      }), o(d), window.scrollTo({ top: 0 }), d;
    }
    const l = new URLSearchParams(n);
    for (const [h] of n.entries())
      h.startsWith("facet_") && l.delete(h);
    l.delete("sort");
    const i = l.toString(), g = i ? `${a}?${i}` : a;
    window.location.href = g;
  }
}), _ = async (e, t) => {
  await e.cancelQueries({
    queryKey: ["search", t, "infinite"],
    exact: !1
  }), e.removeQueries({
    queryKey: ["search", t, "infinite"],
    exact: !1
  }), window.scrollTo({ top: 0 });
}, Te = ({
  queryParams: e,
  searchMethods: t,
  urlFacets: r = {},
  urlSort: s = [],
  mode: n = "CLIENT",
  initialSearchResult: a
}) => {
  var S;
  const o = $(), u = w(
    () => E(e, r, s),
    [e, r, s]
  ), c = fe({
    queryKey: u,
    queryFn: async () => {
      if (n === "SSR" && a)
        return a;
      if (Object.keys(r).length > 0 || s.length > 0) {
        const f = await t.fetchSearchResult();
        return await Qe(
          f,
          r,
          s,
          t
        );
      }
      return t.fetchSearchResult();
    },
    initialData: n === "SSR" && a ? a : void 0,
    staleTime: n === "SSR" ? 1 / 0 : void 0,
    refetchOnWindowFocus: !1
  }), d = w(
    () => D(c.data),
    [c.data]
  ), l = w(
    () => [
      "search",
      e,
      "infinite",
      ...L(d)
    ],
    [e, d]
  ), i = pe({
    queryKey: l,
    queryFn: async ({ pageParam: f = 1 }) => {
      var m, R;
      if (f === 1) {
        if (!c.data)
          throw new Error("Cannot start infinite query without search data");
        return c.data;
      }
      const p = await t.loadPage(f, c.data);
      return {
        items: p,
        meta: {
          currentPage: f,
          totalPages: ((m = c.data) == null ? void 0 : m.meta.totalPages) || 0,
          totalItems: ((R = c.data) == null ? void 0 : R.meta.totalItems) || 0,
          itemsPerPage: p.length
        }
      };
    },
    getNextPageParam: (f, p) => {
      var R;
      const m = p.length;
      return m < (((R = f.meta) == null ? void 0 : R.totalPages) || 0) ? m + 1 : void 0;
    },
    initialPageParam: 1,
    enabled: !!c.data,
    refetchOnWindowFocus: !1
  }), g = {
    // Load additional pages using infinite query pattern
    loadPage: C(
      De(
        i,
        t,
        o,
        u,
        () => c.data
      ),
      [
        i,
        t,
        o,
        u,
        c.data
      ]
    ),
    // Apply facet filters and update base cache
    setFacets: C(
      async (f, p) => {
        const m = await t.setFacets(
          f,
          p
        );
        return await _(o, e), o.setQueryData(u, m), m;
      },
      [t, o, u, e, l]
    ),
    // Apply sort order changes
    setSortOrder: C(
      async (f, p) => {
        const m = await t.setSortOrder(
          f,
          p
        );
        return await _(o, e), o.setQueryData(u, m), m;
      },
      [t, o, e, l]
    ),
    // Reset search to initial state
    reset: C(async () => c.data || await c.refetch().then((f) => f.data), [c])
  }, h = w(
    () => {
      var f;
      return ((f = i.data) == null ? void 0 : f.pages.flatMap((p) => Array.isArray(p) ? p : p && typeof p == "object" && "items" in p ? p.items : [])) || [];
    },
    [i.data]
  );
  return {
    results: w(
      () => {
        var f;
        return c.data ? {
          ...c.data,
          items: h.length > 0 ? h : c.data.items,
          meta: {
            ...c.data.meta,
            currentPage: ((f = i.data) == null ? void 0 : f.pages.length) || 1
          }
        } : void 0;
      },
      [c.data, h, (S = i.data) == null ? void 0 : S.pages.length]
    ),
    queryMethods: g
  };
}, Ue = (e, t, r, s) => {
  const n = D(r), a = [
    "search",
    t,
    "infinite",
    ...L(n)
  ], o = D(s), u = [
    "search",
    t,
    "infinite",
    ...L(o)
  ], c = e.getQueryData(a);
  if (c != null && c.pages && c.pages.length > 1) {
    const d = {
      ...c,
      pages: [s, ...c.pages.slice(1)],
      pageParams: c.pageParams
    };
    e.setQueryData(u, d);
  }
}, Ae = ({
  queryParams: e,
  searchMethods: t,
  mode: r = "CLIENT",
  initialSearchResult: s,
  children: n
}) => {
  const a = P(b), o = $();
  if (!a)
    throw new Error(
      "CachedSearchResultsProvider must be used within a SearchProvider"
    );
  const { searchData: u } = a, c = u.urlSearchParams, d = w(
    () => ke(c),
    [c.toString()]
  ), l = w(
    () => Ie(c),
    [c.toString()]
  ), { results: i, queryMethods: g } = Te({
    queryParams: e,
    searchMethods: t,
    urlFacets: d,
    urlSort: l,
    mode: r,
    initialSearchResult: s
  }), h = (f, p) => {
    const m = f.reduce(
      (V, K) => {
        const O = T(K);
        return O.length > 0 && (V[K.id] = O), V;
      },
      {}
    ), R = te(p);
    return { urlFacetsData: m, urlSortData: R };
  }, y = C(
    (f) => {
      Ue(o, e, i, f);
    },
    [o, e, i]
  ), S = Le(
    g,
    o,
    e,
    i,
    c,
    u.pathname,
    y,
    h
  );
  return /* @__PURE__ */ v(X.Provider, { value: S, children: /* @__PURE__ */ v(Y, { result: i, children: n }) });
};
Ae.displayName = "CachedSearchResultsProvider";
function U() {
  const e = P(z);
  if (e === void 0)
    throw new Error(
      "useSearchResultDispatch must be used within a SearchResultProvider"
    );
  return e;
}
const A = () => {
  const e = P(X);
  if (e === void 0)
    throw new Error(
      "useSearchResultQueryMethods must be used within a SearchResultProvider"
    );
  return e;
}, Ze = () => {
  const e = P(b);
  if (!e)
    throw new Error(
      "useGlobalSearchSettings must be used within a SearchProvider"
    );
  return e.globalSearchSettings;
}, se = () => {
  const e = P(b);
  if (!e)
    throw new Error("useSearchData must be used within a SearchProvider");
  return e.searchData;
}, Ve = () => {
  const { loadPage: e } = A(), { result: t } = F(), r = U();
  return async (s) => {
    const n = await e(s, t);
    r({ type: "LOAD_PAGE", payload: { items: n, page: s } });
  };
}, ne = () => {
  const { result: e } = F();
  return e == null ? void 0 : e.meta;
}, Ke = () => {
  const { urlSearchParams: e, pathname: t } = se(), r = ne(), s = r ? r.currentPage + 1 : 0, n = new URLSearchParams(e);
  return n.set("page", s.toString()), `${t}?${n.toString()}`;
}, ze = () => {
  const e = j(!1), t = ne(), r = Ke(), s = Ve(), [n, a] = ue(!1);
  if (!t)
    return {
      loadMore: () => {
      },
      canLoadMore: !1,
      paginationStats: { totalItems: 0, seen: 0 },
      isLoading: !1,
      pageIncrementHref: r
    };
  const { currentPage: o, totalPages: u, itemsPerPage: c, totalItems: d } = t;
  o === 0 && !e.current && (e.current = !0);
  const l = o + (e.current ? 1 : 0) < u, i = () => {
    if (l)
      return a(!0), s(o + 1).finally(() => a(!1));
    console.warn(
      `Tried to load more products than available, currentPage: ${o}, totalPages: ${u}`
    );
  }, g = (o + (e.current ? 1 : 0)) * c > d ? d : (o + (e.current ? 1 : 0)) * c;
  return {
    loadMore: i,
    canLoadMore: l,
    paginationStats: { totalItems: d, seen: g },
    isLoading: n,
    pageIncrementHref: r
  };
}, Je = () => {
  const e = F(), t = U(), { setSortOrder: r } = A(), s = w(() => {
    var a;
    return ((a = e.result) == null ? void 0 : a.sort) || [];
  }, [e.result]), n = C(
    async (a) => {
      const o = s.map((c) => c.id === a ? {
        ...c,
        selected: !c.selected
      } : {
        ...c,
        selected: !1
        // Only one sort can be selected at a time
      });
      if (!o)
        return;
      const u = await r(o, e.result);
      t({ type: "SET_RESULT", payload: u });
    },
    [s, r, t]
  );
  return { sortAlternatives: s, toggleSort: n };
}, Oe = (e, t) => {
  const r = [], s = /* @__PURE__ */ new Set();
  for (const a of t) {
    const o = e.filter(
      (u) => a.facetIds.includes(u.id) && (u.type === "checkbox" || u.type === "checkbox-hierarchical")
    );
    if (o.length > 0) {
      const u = o.reduce(
        (d, l) => d + l.selectedCount,
        0
      ), c = {
        id: a.id,
        name: a.name,
        type: "group",
        children: o,
        selectedCount: u,
        relationship: a.relationship || "or",
        compositeField: a.compositeField
      };
      r.push(c), o.forEach((d) => s.add(d.id));
    }
  }
  const n = e.filter(
    (a) => !s.has(a.id)
  );
  return r.push(...n), r;
}, ce = (e) => {
  if (e.type === "group")
    return {
      ...e,
      children: e.children.map(ce)
    };
  if (e.type === "checkbox")
    return {
      ...e,
      values: e.values.filter((t) => t.name !== "undefined")
    };
  if (e.type === "checkbox-hierarchical") {
    const t = (r) => r.filter((s) => s.name !== "undefined").map((s) => ({
      ...s,
      children: s.children ? t(s.children) : void 0
    }));
    return {
      ...e,
      values: t(e.values)
    };
  }
  return e;
}, oe = (e) => e.type === "group" ? e.children.some(oe) : e.type === "checkbox" || e.type === "checkbox-hierarchical" ? e.values.length > 0 : !0, Xe = () => {
  const e = ye(), t = me(), r = ve(), s = F(), n = U(), { setFacets: a, reset: o } = A(), u = w(() => {
    var g;
    if (!((g = s.result) != null && g.facets))
      return [];
    let i = s.result.facets.sort((h, y) => e.facets === "count" ? 0 : e.facets === "name" ? h.name.localeCompare(y.name) : 0).filter((h) => h.id && !t.includes(h.id));
    if (r) {
      const h = r();
      i = Oe(i, h);
    }
    return i = i.map(ce), i = i.filter(oe), i;
  }, [
    s.result,
    e.facets,
    t,
    r
  ]), c = w(() => {
    const i = [], g = (h) => {
      h.type === "checkbox-hierarchical" ? Ee(
        h.values
      ).forEach((S) => {
        i.push({
          name: S.name,
          id: S.id,
          facetId: h.id
        });
      }) : h.type === "checkbox" ? h.values.forEach((y) => {
        y.selected && i.push({
          name: y.name,
          id: y.id,
          facetId: h.id
        });
      }) : h.type === "group" && h.children.forEach(g);
    };
    return u.forEach(g), i;
  }, [u]), d = C(
    async (i, g) => {
      const h = u.map((S) => {
        if (S.type === "group") {
          const f = S.children.map((p) => {
            if (p.id === i) {
              if (p.type === "checkbox-hierarchical")
                return k(p, g);
              if (p.type === "checkbox")
                return Q(p, g);
            }
            return p;
          });
          return {
            ...S,
            children: f,
            selectedCount: f.reduce(
              (p, m) => p + m.selectedCount,
              0
            )
          };
        } else if (S.id === i) {
          if (S.type === "checkbox-hierarchical")
            return k(S, g);
          if (S.type === "checkbox")
            return Q(S, g);
        }
        return S;
      }), y = await a(
        h,
        s.result
      );
      n({ type: "SET_RESULT", payload: y });
    },
    [u, a, n, s.result]
  );
  return { facets: u, toggleFacet: d, resetFacets: async () => {
    const i = await o();
    n({ type: "SET_RESULT", payload: i });
  }, activeFacetValues: c };
}, Ye = ({
  zeroIndexed: e = !1
} = {}) => {
  const { urlSearchParams: t } = se(), r = t.get("page"), s = r ? parseInt(r) : 1;
  return (isNaN(s) || s < 1 ? 1 : s) - (e ? 1 : 0);
}, qe = {
  items: [],
  meta: {
    totalItems: 0,
    currentPage: 1,
    totalPages: 1,
    itemsPerPage: 0
  },
  facets: [],
  sort: []
}, et = (e) => e.relationship !== "and" ? [] : e.children.map((t) => ({
  facetId: t.id,
  valueIds: t.values.filter((r) => r.selected).map((r) => r.id)
})).filter((t) => t.valueIds.length > 0);
export {
  Ge as AutoCompleteProvider,
  Ae as CachedSearchResultsProvider,
  Pe as SearchProvider,
  Y as SearchResultProvider,
  G as SearchResultReactQueryProvider,
  be as StructuredDataSearchProducts,
  Ne as autoCompleteClientMethods,
  Be as clearSearchUrlParameters,
  I as collectSelectedCheckboxHierarchicalValues,
  re as collectSelectedHierarchicalIds,
  Ee as collectTopMostSelectedCheckboxHierarchicalValues,
  Le as createEnhancedQueryMethods,
  L as createFilterKeyFragment,
  De as createLoadPageMethod,
  qe as emptySearchResult,
  N as excludedFacetsContext,
  D as extractFilterState,
  T as extractSelectedFacetIds,
  te as extractSelectedSortIds,
  W as facetGroupingContext,
  H as facetSortingContext,
  ce as filterUndefinedValues,
  E as generateSearchQueryKey,
  et as getAndGroupActiveSelections,
  Oe as groupFacets,
  oe as hasValues,
  Ue as migrateInfiniteQueryData,
  ke as parseUrlFacets,
  Ie as parseUrlSort,
  Qe as restoreSelectionsFromUrl,
  b as searchContext,
  X as searchResultQueryMethodsContext,
  Re as searchResultReducer,
  z as searchResultReducerDispatch,
  Z as searchResultReducerState,
  Q as toggleCheckboxFacet,
  k as toggleHierarchicalFacet,
  M as updateUrlWithSearchState,
  xe as useAutoCompleteClient,
  We as useAutoCompleteSearch,
  Te as useCachedSearchResults,
  Ye as useCurrentPaginationPage,
  me as useExcludedFacets,
  ve as useFacetGrouping,
  ye as useFacetSorting,
  Xe as useFacets,
  Ze as useGlobalSearchSettings,
  Ke as usePageIncrementedHref,
  se as useSearchData,
  U as useSearchResultDispatch,
  Ce as useSearchResultItems,
  ze as useSearchResultLoadMore,
  Ve as useSearchResultLoadPage,
  ne as useSearchResultMeta,
  A as useSearchResultQueryMethods,
  F as useSearchResultState,
  Je as useSort,
  J as useStructuredDataProductsMapper
};
